<template>
  <div class="wrapper perfect-theme-design">
    <div class="content">
      <div class="title">
        <div>
          <!-- <span class="require">*</span> -->
          混堆设计类型
        </div>
        <div v-if="$route.query.class !== 'detail'">
          <el-button
            type="primary"
            plain
            v-if="employeeLevel > 50"
            @click="handleAddRow()"
            >新增</el-button
          >
          <el-button type="warning" plain @click="handleReset()"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="mixPackListPagination.length">
      <div class="info">
        <el-row
          class="header"
          type="flex"
          align="middle"
          justify="center"
          style="margin-bottom:20px;"
        >
          <el-col :span="3">
            <!-- <span class="require" v-if="employeeLevel > 50">*</span> -->
            混堆类型名称
          </el-col>
          <el-col :span="4">
            <!-- <span class="require" v-if="employeeLevel > 50">*</span> -->
            填写混堆规格
          </el-col>
          <el-col :span="employeeLevel > 50 ? 7 : 13">
            <!-- <span class="require" v-if="employeeLevel > 50">*</span> -->
            混堆设计图
          </el-col>
          <el-col :span="6" v-if="employeeLevel > 50">
            开放区域
          </el-col>
          <el-col :span="4">操作</el-col>
        </el-row>

        <el-row
          v-for="(item, index) in mixPackListPagination"
          :key="index"
          class="detail"
          type="flex"
          align="middle"
          justify="center"
        >
          <!-- <el-col :span="6">{{ item.name }}</el-col> -->

          <el-col :span="3">
            <el-tooltip
              effect="light"
              :content="item.defineName"
              placement="top"
              :disabled="employeeLevel > 50"
            >
              <el-input
                v-model="item.defineName"
                clearable
                filterable
                placeholder="混堆名称"
                :disabled="!item.canUpdate && ($route.query.class === 'detail' || employeeLevel <= 50 )"
                @blur="checkName"
              />
            </el-tooltip>
          </el-col>

          <el-col :span="4">

            <el-input
              v-model.number="item.row"
              placeholder="行"
              :disabled="!item.canUpdate && ($route.query.class === 'detail' || employeeLevel <= 50 || isUpdate)"
              style="width:50px"
              @input="checkInput($event, index, 'row')"
            />
            <span style="padding: 0 5px">*</span>
            <el-input
              v-model.number="item.column"
              placeholder="列"
              :disabled="!item.canUpdate && ($route.query.class === 'detail' || employeeLevel <= 50 || isUpdate)"
              style="width:50px"
              @input="checkInput($event, index, 'column')"
            />
          </el-col>
          <el-col :span="employeeLevel > 50 ? 7 : 13">
            <div
              v-if="item.brandList.length"
              class="design-thumbnail"
              title="查看详情"
              @click="viewDesignDetail(index)"
            >
              <div
                class="design-thumbnail-column"
                v-for="(cItem, cIndex) in item.brandList"
                :key="cIndex"
              >
                <div
                  class="design-thumbnail-row"
                  v-for="(rItem, rIndex) in getLine('row', getIndex(index))"
                  :key="rIndex"
                  :style="`background:${cItem.tradeStackColor}`"
                ></div>
              </div>
            </div>
            <el-button
              v-else
              type="success"
              plain
              @click="handleAddDesignDiagram(item, getIndex(index))"
              >添加</el-button
            >
          </el-col>
          <!-- 选择区域 -->
          <el-col class="region-wrapper" :span="6" v-if="employeeLevel > 50 && regionListByBu">
            <div style="margin-bottom: 10px">
              <el-checkbox-button v-model="item.checkAll" @change="handleCheckAllChange($event, item)">
                {{ item.checkAll ? "取消全选" : "全选" }}
              </el-checkbox-button>
            </div>
            <el-checkbox-group v-model="item.regionCodeList" @change="handleRegionChange($event, item)">
              <el-checkbox-button
                v-for="item in regionListByBu"
                :label="item.orgCode"
                :key="item.orgId"
                :disabled="!item.canUpdate && $route.query.class === 'detail'"
              >
                {{ item.orgName.split('|')[0] }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-col>

          <el-col :span="4" v-if="employeeLevel > 50">
            <!-- <el-button :disabled="$route.query.class === 'detail'" v-if="getIndex(index) === 0" type="primary" plain @click="handleAddRow(index)">新增</el-button> -->
            <el-button
              :disabled="$route.query.class === 'detail'"
              type="danger"
              plain
              @click="handleDeleteRow(getIndex(index))"
              >删除</el-button
            >
          </el-col>

          <el-col :span="4" v-else>
            <!-- <el-checkbox :disabled="$route.query.class === 'detail'" v-model="checkedIndexList[getIndex(index)]" @change="handleCheckItem($event, getIndex(index))"></el-checkbox> -->
            <el-checkbox
              :disabled="$route.query.class === 'detail'"
              v-model="checkedIndexList[getIndex(index)]"
            ></el-checkbox>
          </el-col>
        </el-row>

        <!-- 设计图选择 -->
        <div class="card-wraper" v-if="showDesignCard">
          <el-card class="box-card">
            <div slot="header" class="card-header">
              <span>{{ mixPackList[indexSelected].defineName }}</span>
              <span>{{ mixPackList[indexSelected].stackPackSize }}</span>
            </div>
              <div class="card-select">
              <div class="card-box"
                v-for="(item, index) in getLine('column', indexSelected)"
                :key="index"
              >
                <el-select
                  v-if="!mixPackList[indexSelected].brandList.length"
                  v-model="brandSelected[index]"
                  placeholder="选择子品牌"
                  size="mini"
                  filterable
                  :style="{paddingRight:item < getLine('column', indexSelected) ? '5px' : '0px'}"
                >
                  <template v-for="item in subBrandList">
                    <!-- 混堆设计时选择子品牌 不允许再选择‘混堆’ 因此剔除 -->
                    <el-option
                      v-if="item.parentBrandCode !== 'BUDHD'"
                      :key="item.abiBrandId"
                      :label="item.abiBrandDesc"
                      :value="`${item.abiBrandCode},${item.abiBrandDesc},${item.tradeStackColor}`"
                    >
                    </el-option>
                  </template>
                </el-select>
                <div v-else style="text-align: center">
                  {{ getBrandDesc(brandSelected[index]) }}
                </div>
                <div
                  class="card-item"
                  :style="{ backgroundColor: brandSelected[index] ? getBrandInfo('color', index) : '#fff' }"
                  v-for="rItem in getLine('row', indexSelected)"
                  :key="rItem"
                >
                  {{ brandSelected[index] ? getBrandInfo("name", index) : "" }}
                </div>
              </div>
            </div>
            <div class="card-operte">
              <el-button type="primary" @click="cancelDesign">取消</el-button>
              <el-button
                v-if="mixPackList[indexSelected].brandList.length === 0"
                type="danger"
                @click="confirmDesign"
                >确定生成</el-button
              >
            </div>
          </el-card>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="mixPackList.length"
        >
        </el-pagination>
      </div>
    </div>

    <div v-else style="text-align:center">
      您暂未配置混堆套餐
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  // 混堆设计相关
  name: 'perfect-theme-config-design',
  props: {
    employeeLevel: {
      type: Number
    },
    originDefineInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tradeStackThemeDefineDTO: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedOrgCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mixPackList: [
        {
          defineType: '01', // 定义类型，01-堆箱 03-必备品 04-组合陈列
          stackType: '02', // 堆箱类型 01-单堆 02-混堆
          canUpdate: true,
          defineName: '混堆1',
          stackPackSize: '',
          row: '',
          column: '',
          brandList: [],
          stackPackSubBrands: '',
          regionCodeList: [],
          checkAll: false
        }
      ],
      mixPackListSelected: [],
      mixPackListOrigin: [],
      oldStackSizeList: [],
      newStackSizeList: [],
      subBrandList: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      showDesignCard: false,
      indexSelected: 0,
      brandSelected: [],
      // brandInfoMap: {},
      checkedIndexList: [],
      checkedResult: true
    }
  },
  watch: {
    originDefineInfo () {
      if (
        this.$route.query.handleType === 'update' &&
        this.originDefineInfo &&
        JSON.stringify(this.originDefineInfo) !== '{}'
      ) {
        if (!(this.employeeLevel > 50)) {
          // let mixinPackScopeList
          if (this.originDefineInfo.tradePerfectTaskDefineList.length) {
            this.originDefineInfo.tradePerfectTaskDefineList.forEach(item => {
              if (item.taskType === '01' && item.mixinPackScopeList) {
                this.formatStackData(item.mixinPackScopeList)
                this.mixPackList = _.cloneDeep(item.mixinPackScopeList)
              }
            })
          }

          if (this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length) {
            this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.forEach(
              item => {
                if (item.taskType === '01' && item.mixinPackScopeList) {
                  this.formatStackData(item.mixinPackScopeList)
                  this.mixPackListSelected = _.cloneDeep(
                    item.mixinPackScopeList
                  )
                }
              }
            )
          }

          this.setDefalutSelected()
        }
        // -----------------------------------------------------
        // update时
        if (this.employeeLevel > 50) {
          if (this.originDefineInfo.tradePerfectTaskDefineList.length) {
            this.originDefineInfo.tradePerfectTaskDefineList.forEach(item => {
              if (item.taskType === '01') {
                this.oldStackSizeList = item.stackSizeScope
                  ? item.stackSizeScope.split(',')
                  : []
              }
            })
          }
          // 如果bu自建的堆箱规格 也要添加到堆箱设计下拉列表里
          if (this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length) {
            this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.forEach(item => {
              if (item.taskType === '01') {
                if (item.buStackSizeScope) {
                  this.oldStackSizeList = this.oldStackSizeList.concat(item.buStackSizeScope.split(','))
                }
              }
            })
          }
        }

        // -----------------------------------------------------
      }
    },
    tradeStackThemeDefineDTO () {
      if (
        this.tradeStackThemeDefineDTO &&
        JSON.stringify(this.tradeStackThemeDefineDTO) !== '{}'
      ) {
        // this.tradeStackThemeDefineDTO.subBrandList.forEach((item, index) => {
        //  this.brandInfoMap[item.abiBrandCode] = {
        //    'color': item.tradeStackColor,
        //    'name': item.abiBrandName
        //  }
        // })
        this.subBrandList = this.tradeStackThemeDefineDTO.subBrandList
        // ----------------------------------------------------
        // config时
        if (
          this.$route.query.handleType === 'config' &&
          this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length
        ) {
          this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.forEach(
            item => {
              if (item.taskType === '01') {
                this.oldStackSizeList = item.stackSizeScope
                  ? item.stackSizeScope.split(',')
                  : []
              }
            }
          )
        }
        // -----------------------------------------------------s
        if (
          this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList &&
          this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length
        ) {
          if (
            (!(this.employeeLevel > 50) &&
              this.$route.query.handleType === 'config') ||
            this.employeeLevel > 50
          ) {
            if (
              this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length
            ) {
              this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.forEach(
                item => {
                  if (item.taskType === '01' && item.mixinPackScopeList) {
                    this.formatStackData(item.mixinPackScopeList)
                    this.mixPackListOrigin = _.cloneDeep(item.mixinPackScopeList)
                    this.mixPackList = _.cloneDeep(item.mixinPackScopeList)
                    this.filterDataByRegion()
                  }
                }
              )
            }

            // this.mixPackList = JSON.parse(JSON.stringify(this.tradeStackThemeDefineDTO.mixinPackScopeList))
          }
        }
      }
    },
    mixPackList () {
      for (let i = 0; i < this.mixPackList.length; i++) {
        if (typeof this.checkedIndexList[i] !== 'boolean') {
          this.checkedIndexList[i] = false
        }
      }
      // bu 新配置时
      // if (this.employeeLevel > 50 && this.$route.query.handleType === 'config') {
      //   if (this.mixPackList.length) {
      //     this.mixPackList.forEach((item, index) => {
      //       item.name = '混堆' + (this.mixPackList.length - index)
      //     })
      //   }
      // }
      // if (this.employeeLevel > 50 && this.$route.query.handleType === 'update') {
      //   this.mixPackList.forEach((item, index) => {
      //     item.name = '混堆' + (this.mixPackList[(this.mixPackList.length - 1)][2] + 1)
      //   })
      // }
    },
    newStackSizeList: {
      handler (newVal, oldVal) {
        let diffItem = []
        // 若删除了单品牌堆箱规格 则对应的选择了该规格的混堆设计也需删除
        if (oldVal && newVal.length < oldVal.length) {
          diffItem = oldVal.filter(item => {
            return newVal.indexOf(item) === -1
          })
        }
        if (this.mixPackList.length) {
          this.mixPackList.forEach((item, index) => {
            if (item.stackPackSize === diffItem[0]) {
              this.mixPackList.splice(index, 1)
            }
          })
        }
      }
    },
    'selectedOrgCode' () {
      this.filterDataByRegion()
    }
  },
  computed: {
    mixPackListPagination () {
      const startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      return this.mixPackList.slice(startIndex, endIndex)
    },
    // 堆箱规格下拉内容
    stackSizeList () {
      if (this.newStackSizeList.length) {
        return this.newStackSizeList
      } else {
        return this.oldStackSizeList
      }
    },
    isUpdate () {
      return this.$route.query.handleType === 'update'
    }
  },
  methods: {
    // 新建时 根据所选区域判断是否展示堆箱
    filterDataByRegion () {
      // console.log('filterDataByRegion')
      if (this.$route.query.handleType === 'config') {
        this.checkedIndexList = []
        if (!this.selectedOrgCode) {
          this.mixPackList = []
          return
        }
        this.mixPackList = this.mixPackListOrigin.filter((stack) => {
          return stack.regionCodes.indexOf(this.selectedOrgCode) > -1
        })
      }
    },
    // 拆分堆箱 size:2*3 => row:2 column:3
    formatStackData (arr) {
      arr.forEach(stack => {
        stack.row = stack.stackPackSize[0]
        stack.column = stack.stackPackSize[2]
        stack.regionCodeList = stack.regionCodes ? stack.regionCodes.split(',') : []
        this.$set(stack, 'checkAll', false)
      })
    },
    // 输入框输入数据格式化
    checkInput (e, index, type) {
      let value = e.replace(/[^\d]/g, '')
      let item = this.mixPackListPagination[index]
      item[type] = value
    },
    // 获取分页后 元素在数组中的实际index
    getIndex (index) {
      return (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + index
    },
    setDefalutSelected () {
      if (this.employeeLevel > 50 && this.$route.query.handleType === 'config') { return }
      if (this.mixPackList.length && this.mixPackListSelected.length) {
        this.mixPackList.forEach((item, index) => {
          this.mixPackListSelected.forEach(subItem => {
            if (item.defineName === subItem.defineName) {
              this.checkedIndexList[index] = true
            }
          })
        })
      }
    },
    // 添加设计图
    handleAddDesignDiagram (item, index) {
      if (!!item.row && !!item.column) {
        item.stackPackSize = item.row + '*' + item.column
      }
      if (!this.checkName()) {
        return
      }
      if (!item.stackPackSize || !Number(item.row) || !Number(item.column)) {
        this.$message.warning('请正确填写混堆规格')
        return
      }
      this.indexSelected = index
      this.showDesignCard = true
    },
    // 新增
    handleAddRow () {
      if (!this.checkName()) {
        return
      }
      if (
        this.employeeLevel > 50 &&
        this.$route.query.handleType === 'update'
      ) {
        this.mixPackList.unshift({
          // name: '混堆' + (this.mixPackList.length > 0 ? (Number(this.mixPackList[0].name.slice(2)) + 1) : 1),
          defineType: '01', // 定义类型，01-堆箱 03-必备品 04-组合陈列
          stackType: '02', // 堆箱类型 01-单堆 02-混堆
          canUpdate: true,
          defineName: '混堆' + (this.mixPackList.length + 1),
          stackPackSize: '',
          row: '',
          column: '',
          brandList: [],
          regionCodeList: [],
          checkAll: false
        })
      } else {
        this.mixPackList.unshift({
          defineType: '01', // 定义类型，01-堆箱 03-必备品 04-组合陈列
          stackType: '02', // 堆箱类型 01-单堆 02-混堆
          canUpdate: true,
          defineName: '混堆' + (this.mixPackList.length + 1),
          stackPackSize: '',
          row: '',
          column: '',
          brandList: [],
          regionCodeList: [],
          checkAll: false
        })
      }
    },
    // 删除混堆
    handleDeleteRow (index) {
      this.$confirm('是否确认删除该混堆类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.mixPackList.splice(index, 1)
        })
        .catch(() => {})
    },
    // 获取当前数据行/列数据
    getLine (type, index) {
      const sizeInfo = this.mixPackList[index].stackPackSize
        ? this.mixPackList[index].stackPackSize.split('*')
        : []
      if (type === 'row') {
        return Number(sizeInfo[0])
      }
      if (type === 'column') {
        return Number(sizeInfo[1])
      }
    },

    // 勾选校验
    handleCheckItem (e, index) {
      if (e) {
        let count = 0
        if (this.checkedIndexList.length) {
          this.checkedIndexList.forEach(item => {
            if (item) {
              count++
            }
            if (count > 5) {
              this.checkedIndexList[index] = false
              this.$message.warning('混堆类型最多允许选择5种')
            }
          })
        }
      }
    },
    cancelDesign () {
      this.showDesignCard = false
      this.resetDesign()
    },
    // 校验为空
    checkUnfinished () {
      let checkedResult = true
      let checked = true
      for (let i = 0; i < this.brandSelected.length; i++) {
        if (!this.brandSelected[i]) {
          checked = false
        }
      }

      if (
        !checked ||
        this.brandSelected.length < this.getLine('column', this.indexSelected)
      ) {
        checkedResult = false
        this.$message.warning('请正确选择所有品牌')
      }
      return checkedResult
    },

    // 校验套餐重复
    checkSame () {
      let checkedResult = true
      let nowName = this.mixPackList[this.indexSelected].defineName
      let nowSize = this.mixPackList[this.indexSelected].stackPackSize
      let nowBrandStr = ''
      let brandSelectedArr = Object.assign([], this.brandSelected)

      // 组装当前操作套餐所选的品牌编码字符串
      if (brandSelectedArr.length) {
        let arr = []
        brandSelectedArr.forEach(item => {
          arr.push(item.split(',')[0])
        })
        nowBrandStr = arr.length ? arr.sort().join(',') : ''
      }

      // 组装并比较所有列表里相同规格的套餐品牌
      for (let i = 0; i < this.mixPackList.length; i++) {
        let itemBrandStr = ''
        let item = this.mixPackList[i]
        // 规格相同 名字不是当前套餐 已配置混堆设计
        if (
          item.stackPackSize === nowSize &&
          item.defineName !== nowName &&
          item.brandList.length
        ) {
          let itemBrandArr = []
          item.brandList.forEach(brandInfo => {
            itemBrandArr.push(brandInfo.abiBrandCode)
          })
          itemBrandStr = itemBrandArr.length
            ? itemBrandArr.sort().join(',')
            : ''
        }
        if (nowBrandStr === itemBrandStr) {
          this.$message.warning(`当前设计与套餐 "${item.defineName}" 重复`)
          checkedResult = false
          break
        }
      }

      return checkedResult
    },

    // 校验所选品牌不能唯一
    checkSoleBrand () {
      let checkedResult = true
      let brandSelectedArr = Object.assign([], this.brandSelected)
      let brandArr = []

      // 组成abiBrandCode数组
      if (brandSelectedArr.length) {
        brandSelectedArr.forEach(item => {
          brandArr.push(item.split(',')[0])
        })
      }

      if (brandArr.length > 1) {
        brandArr.sort()
        checkedResult = !(brandArr[0] === brandArr[brandArr.length - 1])
      }

      if (!checkedResult) {
        this.$message.warning('所选子品牌不能唯一')
      }
      return checkedResult
    },

    // 确定生成
    confirmDesign () {
      // 校验为空
      if (!this.checkUnfinished()) {
        return
      }

      // 校验所选品牌不能唯一
      if (!this.checkSoleBrand()) {
        return
      }

      // 校验套餐重复
      if (!this.checkSame()) {
        return
      }

      // 添加
      if (this.brandSelected.length) {
        this.brandSelected.forEach(item => {
          let brandInfo = item ? item.split(',') : []
          this.mixPackList[this.indexSelected].brandList.push({
            abiBrandCode: brandInfo[0],
            abiBrandDesc: brandInfo[1],
            tradeStackColor: brandInfo[2]
          })
        })
      }

      this.showDesignCard = false
      this.resetDesign()
    },

    // 重置
    resetDesign () {
      this.indexSelected = this.$options.data().indexSelected
      this.brandSelected = this.$options.data().brandSelected
    },

    // 获取品牌信息
    getBrandInfo (type, index) {
      if (!this.brandSelected.length) return
      if (type === 'color') {
        return this.brandSelected[index] ? this.brandSelected[index].split(',')[2] : 0
      }
      if (type === 'name') {
        return this.brandSelected[index] ? this.brandSelected[index].split(',')[1] : 0
      }
    },

    // 查看设计图详情
    viewDesignDetail (index) {
      this.brandSelected = []
      this.indexSelected = this.getIndex(index)
      if (this.mixPackList[this.getIndex(index)].brandList.length) {
        this.mixPackList[this.getIndex(index)].brandList.forEach(item => {
          this.brandSelected.push(item.abiBrandCode + ',' + item.abiBrandDesc + ',' + item.tradeStackColor)
        })
      }
      this.showDesignCard = true
      console.log(this.brandSelected)
    },
    // 重置
    handleReset () {
      if (
        this.employeeLevel > 50 &&
        this.$route.query.handleType === 'config'
      ) {
        this.mixPackList = this.$options.data().mixPackList
      } else if (
        !(this.employeeLevel > 50) &&
        this.$route.query.handleType === 'update'
      ) {
        this.checkedIndexList = []
        // this.mixPackList = JSON.parse(JSON.stringify(this.originDefineInfo.mixinPackScopeList))
        if (this.originDefineInfo.tradePerfectTaskDefineList.length) {
          this.originDefineInfo.tradePerfectTaskDefineList.forEach(item => {
            if (item.taskType === '01' && item.mixinPackScopeList) {
              this.formatStackData(item.mixinPackScopeList)
              this.mixPackList = _.cloneDeep(item.mixinPackScopeList)
            }
          })
        }

        this.setDefalutSelected()
      } else {
        this.checkedIndexList = []
        // this.mixPackList = JSON.parse(JSON.stringify(this.tradeStackThemeDefineDTO.mixinPackScopeList))
        if (this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.length) {
          this.tradeStackThemeDefineDTO.tradePerfectTaskDefineList.forEach(
            item => {
              if (item.taskType === '01' && item.mixinPackScopeList) {
                this.formatStackData(item.mixinPackScopeList)
                this.mixPackList = _.cloneDeep(item.mixinPackScopeList)
              }
            }
          )
        }

        this.setDefalutSelected()
      }
      if (this.employeeLevel <= 50 && this.$route.query.handleType === 'config') {
        this.filterDataByRegion()
      }
    },

    // 检查混堆名称
    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('混堆设计类型名称不能为空')
        return
      }
      let nameArr = []
      if (this.mixPackList.length) {
        this.mixPackList.forEach(item => {
          nameArr.push(item.defineName)
        })
      }

      if (!this.sortCheckSame(nameArr)) {
        this.$message.warning('混堆设计类型名称重复')
        return false
      }
      return true
    },

    // 排序查重
    sortCheckSame (checkArr) {
      let arr = Object.assign([], checkArr)
      let checkedResult = true

      if (arr.length) {
        let sortArr = arr.sort()
        for (let i = 0; i < sortArr.length; i++) {
          if (sortArr[i] === sortArr[i + 1]) {
            checkedResult = false
            break
          }
        }
      }
      return checkedResult
    },

    checkData () {
      this.checkedResult = true

      // bu校验 每个套餐内容都不会为空 则通过校验
      if (this.employeeLevel > 50) {
        // 校验混堆名字重复
        this.checkedResult = this.checkName()

        // 需要有堆箱
        if (this.mixPackList.length === 0) this.checkedResult = false

        // 每个套餐内容都不会为空
        if (this.mixPackList.length) {
          this.mixPackList.forEach(item => {
            if (!item.stackPackSize || item.brandList.length <= 0) { this.checkedResult = false }
          })
        }
      }

      // region校验 当有 >= 1个勾选时 则通过校验
      if (this.employeeLevel <= 50) {
        let checkedResult = false
        if (this.checkedIndexList.length) {
          this.checkedIndexList.forEach(item => {
            if (item) checkedResult = true
          })
        }
        this.checkedResult = checkedResult
      }

      // if (!checkedResult) this.$parent.checkedResult = checkedResult
    },

    // 全选/取消全选
    handleCheckAllChange (e, item) {
      if (e) {
        this.regionListByBu.forEach(list => {
          item.regionCodeList.push(list.orgCode)
        })
      } else {
        item.regionCodeList = []
      }
    },

    handleRegionChange (e, item) {
      item.checkAll = this.regionListByBu.every(item => {
        return e.indexOf(item.orgCode) !== -1
      })
    },

    getBrandDesc (val) {
      if (val) {
        let list = val.split(',')
        return list[1]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  color: red;
}
.wrapper {
  position: relative;
  // padding: 10px 30px;
  // border-radius: 10px;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      min-height: 120px;
      border-bottom: 1px solid #ccc;
      padding: 15px 0;
      .design-thumbnail {
        display: flex;
        justify-content: center;
        overflow-x: auto;
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
      .region-wrapper {
        line-height:30px;
        text-align:left;
        padding: 10px 0;
      }
    }
  }
  .card-wraper {
    position: absolute;
    width: 100%;
    height: calc(100% + 120px);
    top: -60px;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
 .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      max-height: 500px;
      padding-bottom: 20px;
      min-width: 350px;
    }
    .card-box{
      margin:auto;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    line-height: initial;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
</style>
